/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import { defineMessages } from 'react-intl'

export const SELECT_PAGE = 'header.SELECT_PAGE'
export const SET_NOTIFICATION = 'header.SET_NOTIFICATION'
export const CANCEL_NOTIFICATION = 'header.CANCEL_NOTIFICATION'

export const NOTIF_SUCCESS = 'NOTIF_SUCCESS'
export const NOTIF_ERROR = 'NOTIF_ERROR'

export const messages = defineMessages({
  LOADING: {
    id: 'LOADING',
    defaultMessage: 'LOADING'
  },
  APPLICANT_TITLE: {
    id: 'header.APPLICANT_TITLE',
    defaultMessage: 'APPLICANT_TITLE'
  },
  INTERPRETER_TITLE: {
    id: 'header.INTERPRETER_TITLE',
    defaultMessage: 'INTERPRETER_TITLE'
  },
  STAFF_TITLE: {
    id: 'header.STAFF_TITLE',
    defaultMessage: 'STAFF_TITLE'
  },
  ACCUEIL_MENU: {
    id: 'header.ACCUEIL_MENU',
    defaultMessage: 'ACCUEIL_MENU'
  },
  OFFER_MENU: {
    id: 'header.OFFER_MENU',
    defaultMessage: 'OFFER_MENU'
  },
  CHAT_MENU: {
    id: 'header.CHAT_MENU',
    defaultMessage: 'CHAT_MENU'
  },
  HISTORY_MENU: {
    id: 'header.HISTORY_MENU',
    defaultMessage: 'HISTORY_MENU'
  },
  CUSTOMER_INTERPRETER_IMPORT_MENU: {
    id: 'header.CUSTOMER_INTERPRETER_IMPORT_MENU',
    defaultMessage: 'CUSTOMER_INTERPRETER_IMPORT_MENU'
  },
  APPLICANT_LIST_MENU: {
    id: 'header.APPLICANT_LIST_MENU',
    defaultMessage: 'APPLICANT_LIST_MENU'
  },
  PAYMENT_IMPORT_MENU: {
    id: 'header.PAYMENT_IMPORT_MENU',
    defaultMessage: 'PAYMENT_IMPORT_MENU'
  },
  CLAIM_SUCCESS: {
    id: 'header.CLAIM_SUCCESS',
    defaultMessage: 'CLAIM_SUCCESS'
  },
  UPDATE_SUCCESS: {
    id: 'header.UPDATE_SUCCESS',
    defaultMessage: 'UPDATE_SUCCESS'
  },
  ERROR: {
    id: 'header.ERROR',
    defaultMessage: 'ERROR'
  },
  PAYING_CUSTOMER_TITLE: {
    id: 'header.PAYING_CUSTOMER_TITLE',
    defaultMessage: 'PAYING_CUSTOMER_TITLE'
  },
  VIDEO_PHONE_TUTORIAL_MENU: {
    id: 'header.VIDEO_PHONE_TUTORIAL_MENU',
    defaultMessage: 'VIDEO_PHONE_TUTORIAL_MENU'
  },
  FAQ: {
    id: 'header.FAQ',
    defaultMessage: 'FAQ'
  },
  DOC: {
    id: 'header.DOC',
    defaultMessage: 'DOC'
  },
  EMAIL_SENT: {
    id: 'header.EMAIL_SENT',
    defaultMessage: 'EMAIL_SENT'
  },
  RESENT_INVITATION: {
    id: 'header.RESENT_INVITATION',
    defaultMessage: 'RESENT_INVITATION'
  },
  RESENT_INVITATION_REFUSED: {
    id: 'header.RESENT_INVITATION_REFUSED',
    defaultMessage: 'RESENT_INVITATION_REFUSED'
  },
  CUSTOMER_IMPORT_TITLE: {
    id: 'header.CUSTOMER_IMPORT_TITLE',
    defaultMessage: 'CUSTOMER_IMPORT_TITLE'
  },
  UPLOAD_FILE_LABEL: {
    id: 'header.UPLOAD_FILE_LABEL',
    defaultMessage: 'UPLOAD_FILE_LABEL'
  },
  XML_ACCEPTED_ONLY: {
    id: 'header.XML_ACCEPTED_ONLY',
    defaultMessage: 'XML_ACCEPTED_ONLY'
  },
  FILE_IMPORTED_SUCCESSFULLY: {
    id: 'header.FILE_IMPORTED_SUCCESSFULLY',
    defaultMessage: 'FILE_IMPORTED_SUCCESSFULLY'
  },
  INTERPRETER_IMPORT_TITLE: {
    id: 'header.INTERPRETER_IMPORT_TITLE',
    defaultMessage: 'INTERPRETER_IMPORT_TITLE'
  },
  XLSX_ACCEPTED_ONLY: {
    id: 'header.XLSX_ACCEPTED_ONLY',
    defaultMessage: 'XLSX_ACCEPTED_ONLY'
  },
  SALARY_PERIOD: {
    id: 'header.SALARY_PERIOD',
    defaultMessage: 'SALARY_PERIOD'
  },
  CONTROL_SALARY_FILE: {
    id: 'header.CONTROL_SALARY_FILE',
    defaultMessage: 'CONTROL_SALARY_FILE'
  },
  CONTROL_INVOICE_FILE: {
    id: 'header.CONTROL_INVOICE_FILE',
    defaultMessage: 'CONTROL_INVOICE_FILE'
  },
  ABACUS_SALARY_FILE: {
    id: 'header.ABACUS_SALARY_FILE',
    defaultMessage: 'ABACUS_SALARY_FILE'
  },
  ABACUS_INVOICE_FILE: {
    id: 'header.ABACUS_INVOICE_FILE',
    defaultMessage: 'ABACUS_INVOICE_FILE'
  },
  ABACUS_IMPORT_INVOICE_FILE: {
    id: 'header.ABACUS_IMPORT_INVOICE_FILE',
    defaultMessage: 'ABACUS_IMPORT_INVOICE_FILE'
  },
  CONTROL_SALARY_DONE: {
    id: 'header.CONTROL_SALARY_DONE',
    defaultMessage: 'CONTROL_SALARY_DONE'
  },
  INVOICE_CHECK_DONE: {
    id: 'header.INVOICE_CHECK_DONE',
    defaultMessage: 'INVOICE_CHECK_DONE'
  },
  INVOICE_BY_EMAIL: {
    id: 'header.INVOICE_BY_EMAIL',
    defaultMessage: 'INVOICE_BY_EMAIL'
  },
  INVOICE_BY_EMAIL_NO: {
    id: 'header.INVOICE_BY_EMAIL_NO',
    defaultMessage: 'INVOICE_BY_EMAIL_NO'
  },
  INVOICE_BY_EMAIL_YES: {
    id: 'header.INVOICE_BY_EMAIL_YES',
    defaultMessage: 'INVOICE_BY_EMAIL_YES'
  },
  PAYING_CUSTOMER_INCLUDED: {
    id: 'header.PAYING_CUSTOMER_INCLUDED',
    defaultMessage: 'PAYING_CUSTOMER_INCLUDED'
  },
  PAYING_CUSTOMER_INCLUDED_PLACEHOLDER: {
    id: 'header.PAYING_CUSTOMER_INCLUDED_PLACEHOLDER',
    defaultMessage: 'PAYING_CUSTOMER_INCLUDED_PLACEHOLDER'
  },
  PAYING_CUSTOMER_EXCLUDED: {
    id: 'header.PAYING_CUSTOMER_EXCLUDED',
    defaultMessage: 'PAYING_CUSTOMER_EXCLUDED'
  },
  PAYING_CUSTOMER_EXCLUDED_PLACEHOLDER: {
    id: 'header.PAYING_CUSTOMER_EXCLUDED_PLACEHOLDER',
    defaultMessage: 'PAYING_CUSTOMER_EXCLUDED_PLACEHOLDER'
  },
})



// WEBPACK FOOTER //
// ./src/constants/Header.js